module.exports = __webpack_public_path__ + "img/real_land_1.e199c99f.png";